module.exports = __webpack_public_path__ + "static/img/Newimg9(1).3a5eb82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Newimg9(1).png
// module id = pkHG
// module chunks = 36